import TreatmentFullLayout from "../../components/TreatmentLayout";
import FemaleImg from "../../assets/images/service/10.jpg"; 

import ImgFemale from "../../assets/images/service_detail/female-urology/01.jpg";
import ImgUTI from "../../assets/images/service_detail/female-urology/02.jpg";
import ImgUTI2 from "../../assets/images/service_detail/female-urology/03.jpg";
import ImgIncontinence from "../../assets/images/service_detail/female-urology/04.jpg";
import ImgFistula from "../../assets/images/service_detail/female-urology/05.jpg";

const FemaleUrology = () => {

const data = {
title:"Female Urology Treatment",
subtitle:"Female Urology Specialist for UTI, Incontinence & Fistula Treatment at BBMH Hospital",

heading:"Best Female Urology Specialist in Bhilwara",
description:"Female urology focuses on diagnosis and treatment of urinary and bladder problems in women such as UTI, urinary incontinence, bladder issues and pelvic floor disorders. At BBMH (Brijesh Banger Memorial Hospital), Dr. Sachitanand Chaurasia provides advanced and confidential treatment for all female urology problems with modern technology and expert care.",

image:FemaleImg,

sections:[

{
title:"What is Female Urology?",
content:"Female urology is a specialized branch of urology that focuses on urinary and pelvic floor problems in women. Women commonly suffer from urinary infections, urine leakage, bladder control issues and fistula problems due to pregnancy, childbirth, hormonal changes or infections. At BBMH (Brijesh Banger Memorial Hospital), advanced diagnosis and modern treatment for all female urology conditions are available under expert care of Dr. Sachitanand Chaurasia.",
image: ImgFemale
},

{
title:"Common Female Urology Problems",
content:"Women commonly experience urinary and bladder-related problems due to infections, childbirth, hormonal changes or pelvic floor weakness. Early diagnosis and proper treatment help prevent complications and improve quality of life.",
list:[
"Recurrent UTI – Frequent urine infections causing burning urination, pain and repeated discomfort.",
"Stress Urinary Incontinence – Leakage of urine while coughing, sneezing, laughing or lifting weight.",
"Urge Incontinence – Sudden strong urge to urinate with inability to control urine.",
"Mixed Incontinence – Combination of stress and urge urinary leakage.",
"Vesicovaginal Fistula (VVF) – Abnormal connection between bladder and vagina causing continuous urine leakage.",
"Ureterovaginal Fistula (UVF) – Urine leakage due to connection between ureter and vagina usually after surgery.",
"Overactive Bladder – Frequent urge to urinate with poor bladder control.",
"Pelvic Floor Disorders – Weak pelvic muscles leading to bladder control problems and urine leakage."
],
image: ImgUTI
},

{
title:"Symptoms of Female Urology Problems",
content:"Women may experience urinary and bladder-related symptoms that affect daily life and comfort. Early consultation with a urologist helps in accurate diagnosis and timely treatment.",
list:[
"Frequent urinary infections – Repeated UTI causing burning, fever and discomfort.",
"Burning during urination – Pain or irritation while passing urine.",
"Leakage of urine – Loss of bladder control during daily activities.",
"Sudden urge to urinate – Strong uncontrollable urge to pass urine.",
"Continuous urine leakage – Constant leakage seen in fistula conditions.",
"Pelvic pain – Pain or heaviness in lower abdomen or pelvic area.",
"Difficulty controlling urine – Inability to hold urine for long time.",
"Urine leakage after delivery or surgery – Weak pelvic muscles or fistula after childbirth or operation."
],
image: ImgUTI2
},

{
title:"Advanced Procedures Available",
content:"At BBMH Hospital, modern and advanced female urology procedures are performed to treat urinary leakage, fistula and bladder control problems safely and effectively. These treatments are minimally invasive and provide faster recovery with long-term relief.",
list:[
"Fistula Repair Surgery – Surgical closure of abnormal connection causing continuous urine leakage.",
"VVF Repair – Advanced surgery to correct vesicovaginal fistula between bladder and vagina.",
"UVF Repair – Treatment for ureterovaginal fistula to restore normal urine flow.",
"Incontinence Correction Surgery – Procedures to control urine leakage and improve bladder control.",
"TVT Procedure – Tension-free vaginal tape surgery for stress urinary incontinence.",
"TOT Procedure – Transobturator tape surgery for safe and effective urine leakage treatment.",
"Minimally Invasive Procedures – Advanced endoscopic and laser treatments with quick recovery.",
"Complete Medical Management – Medicines, lifestyle treatment and follow-up care for bladder problems."
]
},

{
title:"Fistula Treatment (VVF & UVF)",
content:"Urinary fistula is an abnormal connection between urinary tract and vagina causing continuous leakage of urine. It may occur after delivery, surgery or infection. Advanced fistula repair surgery is performed to close the connection and restore normal urinary control. Early treatment provides excellent results and improves quality of life.",
image: ImgFistula
},

{
title:"Urinary Incontinence Treatment",
content:"Urinary incontinence is loss of bladder control that leads to urine leakage during daily activities. Treatment depends on type and severity of the condition and focuses on improving bladder control and quality of life.",
list:[
"Medication & lifestyle treatment – Medicines and healthy habits to control urine leakage.",
"Pelvic floor exercises – Strengthening muscles to improve bladder control.",
"Bladder training – Techniques to control urge and improve urine holding capacity.",
"TVT & TOT surgery – Advanced procedures to treat stress urinary incontinence effectively.",
"Minimally invasive procedures – Modern treatments with faster recovery and long-term relief."
],
image: ImgIncontinence
},

{
title:"Medical Treatment & Care",
content:"Many female urology problems can be effectively managed with proper medical treatment and regular care. Early treatment helps prevent complications and improves bladder health.",
list:[
"Antibiotics for recurrent UTI – Treatment to control repeated urine infections.",
"Bladder control medicines – Medicines to reduce urgency and leakage.",
"Hormonal therapy – Treatment for hormonal imbalance affecting bladder health.",
"Lifestyle modification – Diet, hygiene and fluid management for better bladder control.",
"Regular follow-up – Monitoring and guidance for long-term relief."
]
},

{
title:"Why Choose Dr. Sachitanand Chaurasia for Female Urology Treatment?",
content:"Dr. Sachitanand Chaurasia provides expert and confidential treatment for female urology problems at BBMH (Brijesh Banger Memorial Hospital), Bhilwara. With advanced surgical techniques, modern diagnostic facilities and patient-friendly care, the focus is on accurate diagnosis, safe treatment and long-term relief from urinary problems."
}

],

faq:[
{
q:"What is urinary incontinence?",
a:"Urinary incontinence is leakage of urine due to weak bladder control and can be treated with medicines or surgery."
},
{
q:"Is fistula treatable?",
a:"Yes, vesicovaginal and ureterovaginal fistula can be successfully treated with advanced surgery."
},
{
q:"What is TVT or TOT surgery?",
a:"TVT and TOT are advanced procedures used to treat urine leakage and incontinence in women."
}
]

};

return <TreatmentFullLayout data={data}/>
};

export default FemaleUrology;